import { DittofeedSdk } from "@dittofeed/sdk-web"

let isInitialized = false

export async function initDittofeed() {
    const writeKey =
        "Basic Y2E4NjVmZTAtNmU0OC00Njg3LTkyOTEtNjE5MDkzZDllYmUyOmZjNGEyYjdlMDE1MWVlMzI="
    const host = "https://dittofeed.pitchlane.com"

    if (!writeKey) {
        // Dittofeed API key not configured
        return
    }

    if (isInitialized) {
        return
    }

    try {
        await DittofeedSdk.init({
            writeKey,
            host,
        })
        isInitialized = true
    } catch (error) {
        console.error("Failed to initialize Dittofeed:", error)
    }
}

export const dittofeed = {
    track: async (eventName: string, properties?: Record<string, any>) => {
        // if (!isInitialized) {
        //     await initDittofeed()
        // }
        if (!isInitialized) return

        try {
            DittofeedSdk.track({
                event: eventName,
                properties,
            })
        } catch (error) {
            console.error("Failed to track event in Dittofeed:", error)
        }
    },

    identify: async (userId: string, traits?: Record<string, any>) => {
        // if (!isInitialized) {
        //     await initDittofeed()
        // }
        if (!isInitialized) return

        try {
            DittofeedSdk.identify({
                userId,
                traits,
            })
        } catch (error) {
            console.error("Failed to identify user in Dittofeed:", error)
        }
    },
}
